<template>
  <v-text-field
    :label="$traduccion({ texto: label, tag: tag })"
    :placeholder="placeholder"
    :rules="rules"
    :hint="hint ? hint.toString() : ''"
    :persistent-hint="persistent_hint"
    :type="type"
    hide-spin-buttons
    background-color="white"
    dense
    flat
    :hide-details="hideDetails"
    v-model="valor"
    :disabled="disabled"
    :readonly="readonly"
    :height="height"
    :style="getWidth()"
    :reverse="reverse"
    @keyup="change"
    :clearable="clearable"
    :outlined="outlined"
    autocomplete="disable-autocomplete"
    :min="min"
    :max="max"
  >
    <template v-slot:append-outer>
      <v-tooltip
        bottom
        v-if="hasContent(appendOuterIcon) && hasContent(iconTooltip)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            :class="iconClass + ' mt-2'"
            v-bind="attrs"
            v-on="on"
            :disabled="disabled"
            @click="$emit('iconClicked')"
            >{{ appendOuterIcon }}</v-icon
          >
        </template>
        <span>{{ iconTooltip }}</span>
      </v-tooltip>

      <v-icon      
        :disabled="disabled"
        :class="iconClass + ' mt-2'"
        v-else-if="hasContent(appendOuterIcon)"
        @click="$emit('iconClicked')"
        >{{ appendOuterIcon }}
      </v-icon>
    </template>

    <template v-slot:append>
      <v-tooltip
        bottom
        v-if="hasContent(appendIcon) && hasContent(iconTooltip)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            :disabled="disabled"
            :class="iconClass + ' mt-2'"
            v-bind="attrs"
            v-on="on"
            @click="$emit('iconClicked')"
            >{{ appendIcon }}</v-icon
          >
        </template>
        <span>{{ iconTooltip }}</span>
      </v-tooltip>

      <v-icon
        :disabled="disabled"
        :class="iconClass + ' mt-2'"
        v-else-if="hasContent(appendIcon)"
        @click="$emit('iconClicked')"
        >{{ appendIcon }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import { Utilidades } from "@/Util/Utilidades";
export default {
  name: "TextField",
  props: {
    placeholder: String,
    label: String,
    tag: String,
    reverse: Boolean,
    hint: [Number, String],
    rules: Array,
    type: String,
    persistent_hint: Boolean,
    width: String,
    appendIcon: String,
    disabled: Boolean,
    readonly: Boolean,
    appendOuterIcon: String,
    iconTooltip: String,
    hideDetails: Boolean,
    outlined: Boolean,
    height: {
      type: String,
      default: "40px",
    },
    iconClass: {
      type: String,
      default: "text-primary",
    },
    clearable:{
      type: Boolean,
      default: false,
    },
    value: [String, Number],
    min: Number,
    max: Number
  },
  data: function () {
    return {
      valor: "",
    };
  },
  methods: {
    getWidth() {
      if (!Utilidades.isNullOrUndefinedOrEmpty(this.width)) {
        return "width:" + this.width + " !important";
      } else {
        return "";
      }
    },
    change() {
      this.$emit("change");
    },
    hasContent(item) {
      return !Utilidades.isNullOrUndefinedOrEmpty(item);
    },
  },
  watch: {
    valor: {
      immediate: true,
      handler(novoValor) {
        this.$emit("input", novoValor);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        this.valor = val;
      },
    },
  },
};
</script>